module.exports = __webpack_public_path__ + "img/4.e26f2260.jpg";